import { AxiosInstance } from 'axios';

/* eslint-disable no-underscore-dangle */
export default function applyInterceptResponse(api: AxiosInstance) {
  api.interceptors.response.use(
    res => {
      if (typeof res.data === 'string') {
        if (res.data.includes('Two Factor Auth')) window.location.href = '/accounts/two-factor-auth/';
        else if (res.data.includes('Answer the Question')) window.location.href = '/accounts/validate-security-answer/';
      }
      return res;
    },
    error => {
      if (error?.response?.status >= 400 && error?.response?.status <= 599) {
        console.log(error.message);
      }
      return Promise.reject(error);
    }
  );
}
